import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgWalletIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16 8V4.5007c0-.8318 0-1.2476-.1752-1.5032a1 1 0 0 0-.657-.4204c-.3055-.052-.6831.1223-1.4383.4708L4.859 7.142c-.6735.3108-1.0103.4663-1.2569.7073a2 2 0 0 0-.4866.7605C3 8.9348 3 9.3057 3 10.0475V15m13.5-.5h.01M3 11.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4802 21 18.9201 21 17.8v-6.6c0-1.1201 0-1.6801-.218-2.108a2 2 0 0 0-.874-.874C19.4802 8 18.9201 8 17.8 8H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 9.5198 3 10.08 3 11.2m14 3.3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);
export default SvgWalletIcon;
